<template>
  <div class="myCenterCommon__userContent__2fHEF route-fade-enter-done">
    <div class="myCenterCommon__users_layout__title__3CoQ0">
      <div class="title__title__RTC9P"><b>存款</b><span>存款金额会存入中心钱包</span></div>
    </div>
    <div class="style__depositType_box__3Ls0s undefined">
      <div>
        <div class="style__tk_jr__1bGUA">
          <!-- <ul class="tabs__tabsDeposit__3QKqg">
            <li id="cunkuan1" class="tabs__active__qlOaY">人民币存款</li>
          </ul> -->
          <div class="style__list_box__2YvIs cunkuan1" style="display: block">
            <ul class="index__Checkbox__1YkXt pay-list" style="width: 920px; text-align: center; margin-left: -21px">
              <!--  -->
              <div id="tab1" :class="pay_way == 'bank' ? ' index__Active__3D-PM' : ''" @click="changPayway('bank')" v-if="payWayList.card == 1" style="width: 133px; height: 100px; margin: 0px 0px 20px 20px">
                <li data-analytics="button" style="height: 100%">
                  <img src="https://www.8899851.com/oubo/static/image/icoOnlineTransfer2@3x.png" data-analytics="button" style="height: 36px; margin-top: 20px" />
                  <p>银行卡充值</p>
                </li>
              </div>
              <!---->
              <div id="tab2" :class="pay_way == 'usdt' ? ' index__Active__3D-PM' : ''" @click="changPayway('usdt')" v-if="payWayList.usdt == 1" style="width: 133px; height: 100px; margin: 0px 0px 20px 20px">
                <li data-analytics="button" style="height: 100%">
                  <img src="https://www.8899851.com/oubo/static/image/usdt.png" data-analytics="button" style="height: 36px; margin-top: 20px" />
                  <p>USDT充值</p>
                </li>
              </div>
              <!-- -->
              <div id="tab2" :class="pay_way == 'wechat' ? ' index__Active__3D-PM' : ''" @click="changPayway('wechat')" v-if="payWayList.wechat == 1" style="width: 133px; height: 100px; margin: 0px 0px 20px 20px">
                <li data-analytics="button" style="height: 100%">
                  <img src="https://www.8899851.com/oubo/static/image/QuickWechat.png" data-analytics="button" style="height: 36px; margin-top: 20px" />
                  <p>微信充值</p>
                </li>
              </div>
              <!--  -->
              <div id="tab2" :class="pay_way == 'alipay' ? ' index__Active__3D-PM' : ''" @click="changPayway('alipay')" v-if="payWayList.alipay == 1" style="width: 133px; height: 100px; margin: 0px 0px 20px 20px">
                <li data-analytics="button" style="height: 100%">
                  <img src="https://www.8899851.com/oubo/static/image/pay_alipay.png" data-analytics="button" style="height: 36px; margin-top: 20px" />
                  <p>支付宝充值</p>
                </li>
              </div>
            </ul>
          </div>
        </div>
        <div style="width: 100%; margin-bottom: 20px; display: flex; flex-wrap: wrap" v-if="pay_way == 'bank' && !(userbank.length == 0 && userUSD.length == 0)">
          <div class="usdt__card__1QL7m usdt__mid__2A8wC" style="width: 42%; margin-right: 10px; margin-top: 10px" v-for="(item, index) in cardLis" :key="index">
            <p class="usdt__sub_tip__24nbZ sfff">收款账号：</p>
            <p class="usdt__sub_tip__24nbZ">{{ item.bank_no }} <span class="spanss" @click="doCopy(item.bank_no)">复制</span></p>
            <p class="usdt__sub_tip__24nbZ">银行户名：{{ item.bank_owner }} <span class="spanss" @click="doCopy(item.bank_owner)">复制</span></p>
            <p class="usdt__sub_tip__24nbZ">开 户 行：{{ item.bank_data.bank_name }} <span class="spanss" @click="doCopy(item.bank_data.bank_name)">复制</span></p>
            <p class="usdt__sub_tip__24nbZ">银行地址：{{ item.bank_address }} <span class="spanss" @click="doCopy(item.bank_address)">复制</span></p>
          </div>
        </div>
        <!--  -->
        <div style="margin-top: 20px; display: block" v-if="pay_way == 'bank'">
          <div id="item2" class="style__tk_jr__1bGUA cunkuan1" style="margin-bottom: 20px; display: block">
            <p class="style__text__1D2UV style__depositName__2M33H">存款银行</p>
            <div class="style__input__3HpTW">
              <el-select v-model="bankBox.bank" style="width: 360px" placeholder="请选择支持银行">
                <el-option v-for="item in banklist" :key="item.bank_name" :label="item.bank_name" :value="item.bank_name"> </el-option>
              </el-select>
            </div>
          </div>

          <div id="item2" class="style__tk_jr__1bGUA cunkuan1" style="margin-bottom: 20px; display: block">
            <p class="style__text__1D2UV style__depositName__2M33H">存款人姓名</p>
            <div class="style__input__3HpTW">
              <span><input data-analytics="button" v-model="bankBox.bank_owner" data-label="存款页存款姓名按钮点击次数" data-key="yb_hm_dpst_dspname_tap" type="text" placeholder="请输入信息" value="" class="index__Input__tY5CA" style="width: 286px; height: 40px" /></span
              ><span class="style__tk_ts__302_r"><img src="https://www.8899851.com/oubo/static/image/tisi.8d134098e1e18d283c7886fb98257f6d.svg" /> 为及时到账，请务必输入正确的存款人姓名 </span>
            </div>
          </div>
          <div id="item2" class="style__tk_jr__1bGUA cunkuan1" style="margin-bottom: 20px; display: block">
            <p class="style__text__1D2UV style__depositName__2M33H">银行卡号</p>
            <div class="style__input__3HpTW">
              <span><input data-analytics="button" v-model="bankBox.bank_no" data-label="存款页存款姓名按钮点击次数" data-key="yb_hm_dpst_dspname_tap" type="text" placeholder="请输入银行卡号" maxlength="24" value="" class="index__Input__tY5CA" style="width: 286px; height: 40px" /></span
              ><span class="style__tk_ts__302_r"><img src="https://www.8899851.com/oubo/static/image/tisi.8d134098e1e18d283c7886fb98257f6d.svg" /> 为及时到账，请务必输入正确的银行卡号</span>
            </div>
          </div>
          <div id="item2" class="style__tk_jr__1bGUA cunkuan1" style="margin-bottom: 20px; display: block">
            <p class="style__text__1D2UV style__depositName__2M33H">开户行地址</p>
            <div class="style__input__3HpTW">
              <span><input data-analytics="button" v-model="bankBox.bank_address" data-label="存款页存款姓名按钮点击次数" data-key="yb_hm_dpst_dspname_tap" type="text" placeholder="请输入开户行地址" maxlength="24" value="" class="index__Input__tY5CA" style="width: 286px; height: 40px" /></span
              ><span class="style__tk_ts__302_r"><img src="https://www.8899851.com/oubo/static/image/tisi.8d134098e1e18d283c7886fb98257f6d.svg" /> 为及时到账，请务必输入正确的开户行地址</span>
            </div>
          </div>
          <div id="item3" class="style__tk_jr__1bGUA cunkuan1" style="display: block">
            <span class="style__text__1D2UV style__depositMpney__1s4D0">存款金额</span>
            <div style="margin-bottom: 20px">
              <div class="style__input__3HpTW">
                <input
                  type="text"
                  id="jine_val"
                  v-model="amount"
                  data-analytics="button"
                  data-label="存款页输入框点击次数"
                  :placeholder="`请输入取款金额 ${min_price} - ${max_price}`"
                  data-key="yb_hm_dpst_input_tap"
                  value=""
                  class="index__Input__tY5CA"
                  style="width: 286px; height: 40px; font-weight: 600"
                />
                <span class="style__tk_ts__302_r"><img src="https://www.8899851.com/oubo/static/image/tisi.8d134098e1e18d283c7886fb98257f6d.svg" />建议您存入带尾数的金额（例101、503），以便存款后能更快匹配到账</span>
              </div>
            </div>

            <input type="hidden" id="usdt_rate" value="6.42" />
          </div>
          <div class="style__tk_jr__1bGUA cunkuan1" style="display: block">
            <button data-analytics="button" @click="payTest" data-key="yb_hm_dpst_idpst_tap" class="index__Button__It0J4 index__Button3__1Pn-Q" style="width: 286px; height: 50px; margin-top: 10px">立即存款</button>
          </div>
        </div>
        <!--  -->
        <div style="margin-top: 20px; display: block" v-if="pay_way == 'usdt'">
          <div id="item3" class="style__tk_jr__1bGUA cunkuan1" style="">
            <span class="style__text__1D2UV style__depositMpney__1s4D0">协议：</span>
            <div class="" style="margin-bottom: 9px">
              <div style="display: flex; justify-items: center">
                <ul class="index__Checkbox__1YkXt" style="width: auto; text-align: center; margin-left: -21px; margin-top: 10px">
                  <div id="xieyi1" :class="meyXi == 'TRC20' ? 'index__Active__3D-PM' : ''" @click="changXiyi('TRC20')" style="width: 133px; height: 40px; margin: 0px 0px 20px 20px"><div class="usdt__checkbox_item__1OfBR">TRC20</div></div>
                  <div id="xieyi2" :class="meyXi == 'ERC20' ? 'index__Active__3D-PM' : ''" @click="changXiyi('ERC20')" style="width: 133px; height: 40px; margin: 0px 0px 20px 20px"><div class="usdt__checkbox_item__1OfBR">ERC20</div></div>
                </ul>
                <div>
                  <span class="style__tk_ts__302_r usdt__link__2gOZ4 usdt__protocol_diff__3DxJj" style="margin-left: 13px"><img src="https://www.8899851.com/oubo/static/image/tisi.8d134098e1e18d283c7886fb98257f6d.svg" />选择协议充值。</span>
                </div>
              </div>
              <span class="usdt__protocol_tip__2Olq6">小额高频交易推荐</span>
            </div>
          </div>

          <div id="item3" class="style__tk_jr__1bGUA cunkuan1" style="display: block">
            <span class="style__text__1D2UV style__depositMpney__1s4D0">存款金额</span>
            <div style="margin-bottom: 20px">
              <div class="style__input__3HpTW">
                <input
                  type="text"
                  id="jine_val"
                  v-model="amount"
                  data-analytics="button"
                  data-label="存款页输入框点击次数"
                  :placeholder="`请输入取款金额 ${min_price} - ${max_price}`"
                  data-key="yb_hm_dpst_input_tap"
                  value=""
                  class="index__Input__tY5CA"
                  style="width: 286px; height: 40px; font-weight: 600"
                />
                <span class="style__tk_ts__302_r"><img src="https://www.8899851.com/oubo/static/image/tisi.8d134098e1e18d283c7886fb98257f6d.svg" />建议您存入带尾数的金额（例101、503），以便存款后能更快匹配到账</span>
              </div>
            </div>
            <div class="style__tk_ts__302_r">
              ≈<span class="usdt" style="color: red">{{ amount ? Math.floor((amount / $store.state.userInfo.usdtrate) * 100) / 100 : '0.00' }}</span> USDT &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;参考汇率：{{ $store.state.userInfo.usdtrate }}
            </div>
          </div>
          <div class="style__tk_jr__1bGUA cunkuan1" style="display: block">
            <button @click="payTest" data-analytics="button" data-label="存款页立即存款按钮点击次数" data-key="yb_hm_dpst_idpst_tap" class="index__Button__It0J4 index__Button3__1Pn-Q" style="width: 286px; height: 50px; margin-top: 10px">立即存款</button>
          </div>
        </div>

        <div style="margin-top: 20px; display: block" v-if="pay_way == 'alipay'">
          <div id="item3" class="style__tk_jr__1bGUA cunkuan1" style="display: block">
            <span class="style__text__1D2UV style__depositMpney__1s4D0">存款金额</span>
            <div style="margin-bottom: 20px">
              <div class="style__input__3HpTW">
                <input
                  v-model="amount"
                  type="text"
                  id="jine_val"
                  data-analytics="button"
                  data-label="存款页输入框点击次数"
                  :placeholder="`请输入取款金额 ${min_price} - ${max_price}`"
                  data-key="yb_hm_dpst_input_tap"
                  value=""
                  class="index__Input__tY5CA"
                  style="width: 286px; height: 40px; font-weight: 600"
                />
                <span class="style__tk_ts__302_r"><img src="https://www.8899851.com/oubo/static/image/tisi.8d134098e1e18d283c7886fb98257f6d.svg" />建议您存入带尾数的金额（例101、503），以便存款后能更快匹配到账</span>
              </div>
            </div>
          </div>
          <div class="style__tk_jr__1bGUA cunkuan1" style="display: block">
            <button @click="payTest" data-analytics="button" data-label="存款页立即存款按钮点击次数" data-key="yb_hm_dpst_idpst_tap" class="index__Button__It0J4 index__Button3__1Pn-Q" style="width: 286px; height: 50px; margin-top: 10px">立即存款</button>
          </div>
        </div>
        <div style="margin-top: 20px; display: block" v-if="pay_way == 'wechat'">
          <div id="item3" class="style__tk_jr__1bGUA cunkuan1" style="display: block">
            <span class="style__text__1D2UV style__depositMpney__1s4D0">存款金额</span>
            <div style="margin-bottom: 20px">
              <div class="style__input__3HpTW">
                <input
                  type="text"
                  id="jine_val"
                  v-model="amount"
                  data-analytics="button"
                  data-label="存款页输入框点击次数"
                  :placeholder="`请输入取款金额 ${min_price} - ${max_price}`"
                  data-key="yb_hm_dpst_input_tap"
                  value=""
                  class="index__Input__tY5CA"
                  style="width: 286px; height: 40px; font-weight: 600"
                />
                <span class="style__tk_ts__302_r"><img src="https://www.8899851.com/oubo/static/image/tisi.8d134098e1e18d283c7886fb98257f6d.svg" />建议您存入带尾数的金额（例101、503），以便存款后能更快匹配到账</span>
              </div>
            </div>
          </div>
          <div class="style__tk_jr__1bGUA cunkuan1" style="display: block">
            <button @click="payTest" data-analytics="button" data-label="存款页立即存款按钮点击次数" data-key="yb_hm_dpst_idpst_tap" class="index__Button__It0J4 index__Button3__1Pn-Q" style="width: 286px; height: 50px; margin-top: 10px">立即存款</button>
          </div>
        </div>
      </div>
    </div>
    <!-- 没有绑定 -->
    <!--  -->
    <div class="msgBox__modal__2kbbd" data-analytics="button" data-label="msg关闭" v-if="userbank.length == 0 && userUSD.length == 0" style="display: block">
      <div class="msgBox__modal_HomeAreat_model__2obMO msgBox__modal_CuorsterAreat_model__wwzuA">
        <div class="msgBox__notice_header__kkFdX"><span class="msgBox__text__2ODn2" title="">温馨提示</span><span class="msgBox__close_icon__3J9a5" @click="$router.back()"></span></div>
        <div class="msgBox__notice_content__3Tozy msgBox__notice_content_height__Z3O1m">
          <div class="msgBox__flex__-7cOr common__scroll_bar__28TB7">您还为绑定钱包卡片，请前往添加！</div>
          <div class="msgBox__footer__3DHzZ"><button class="msgBox__confirm__3ypnx" type="button" @click="$parent.goNav('/bankCard')">前往绑定</button></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'recharge',
  data() {
    return {
      pay_way: 'rengong',
      bankBox: {},
      payInfo: {},
      amount: null,
      cardLis: [],
      banklist: [1],
      bankBox: {},
      meyXi: 'ERC20',
      payWayList: {},
      userbank: [],
      userUSD: [1],
      min_price: 100,
      max_price: 10000,
    };
  },
  created() {
    let that = this;
    that.getPayWay();
    that.getBanklist();
    that.getcard();

    // that.getuseCardlist();
  },
  methods: {
    getPayRange() {
      let that = this;
      let type = null;

      if (that.pay_way == 'bank') {
        type = 'bank';
      }
      if (that.pay_way == 'wechat') {
        type = 'wechat';
      }
      if (that.pay_way == 'alipay') {
        type = 'alipay';
      }
      if (that.pay_way == 'alipay') {
        type = 'alipay';
      }
      if (that.pay_way == 'usdt') {
        if (that.meyXi == 'ERC20') {
          type = 'usdt-erc20';
        }
        if (that.meyXi == 'TRC20') {
          type = 'usdt-trc20';
        }
      }
      // bank/wechat/alipay/usdt-erc20/usdt-trc20/ebpay    min_price max_price
      that.showLoading();

      that.$apiFun
        .post('/api/getPayRange', { type })
        .then(res => {
          if (res.code == 200) {
            that.min_price = res.data.min_price;
            that.max_price = res.data.max_price;
          }
          that.hideLoading();
        })
        .catch(res => {
          that.hideLoading();
        });
    },
    changXiyi(val) {
      if (this.meyXi == val) {
        return;
      }
      this.meyXi = val;
      this.getPayRange();
    },
    getPayWay() {
      let that = this;
      that.showLoading();

      that.$apiFun
        .get('/api/get_pay_way', {})
        .then(res => {
          if (res.code == 200) {
            that.payWayList = res.data;
            that.payWayList.rengong = 1;
            let obj = that.payWayList;
            for (let i in obj) {
              if (obj[i] == 1) {
                that.pay_way = i == 'card' ? 'bank' : i;
                that.hideLoading();
                that.getPayRange();

                return;
              }
            }
          }

          that.hideLoading();
        })
        .catch(res => {
          that.hideLoading();
        });
    },
    payTest() {
      let that = this;
      let info = {};

      // bank 情况下  bank  bank_address  bank_no  bank_owner
      if (that.pay_way == 'bank') {
        info = {
          paytype: that.pay_way,
          amount: that.amount * 1,
          bank: that.bankBox.bank,
          bank_address: that.bankBox.bank_address,
          bank_no: that.bankBox.bank_no,
          bank_owner: that.bankBox.bank_owner,
        };
        console.log(info);
        // 银行卡信息内容的限制
        if (!info.bank_owner) {
          that.showTost(0, '请输入存款人姓名');
          return;
        }
        if (!info.bank) {
          that.showTost(0, '请输入银行类型');
          return;
        }

        if (!info.bank_no) {
          that.showTost(0, '请输入银行卡号');
          return;
        }
        if (!info.bank_address) {
          that.showTost(0, '请输入银行开户行地址');
          return;
        }
      } else {
        //暂时
        info = {
          paytype: that.pay_way,
          amount: that.amount * 1,
        };
      }
      if (that.pay_way == 'usdt') {
        info.catepay = that.meyXi;
      }
      // usdt 情况下  catepay 必填

      // 支付的金额判断
      // 支付的金额判断
      if (info.amount < that.min_price || info.amount > that.max_price) {
        that.showTost(0, `请输入金额在${that.min_price}-${that.max_price}之间！`);
        return;
      }
      that.showLoading();
      info.paytype = info.paytype == 'wechat' ? 'wxpay' : info.paytype;

      that.$apiFun
        .post('/api/recharge', info)
        .then(res => {
          console.log(res);
          if (res.code != 200) {
            that.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.amount = null;
            if (that.pay_way == 'bank') {
              that.showTost(1, '提交成功，等待后台审核');
              that.bankBox = {};
              that.amount = null;
              that.hideLoading();
              setTimeout(() => {
                that.$router.push({ path: '/transRecord' });
              }, 2000);
              return;
            }
            that.bankBox = {};
            that.amount = null;
            that.showTost(1, '正在跳转...');
            setTimeout(() => {
              that.$router.push({ path: '/transRecord' });
            }, 2000);
            const routeData = this.$router.resolve({
              path: '/payInfo',
              query: { deposit_no: res.message },
            });

            window.open(routeData.href, '_blank');
          }
          that.hideLoading();
        })
        .catch(res => {
          that.hideLoading();
        });
    },
    changMey(val) {
      this.amount = val * 1;
    },
    getBanklist() {
      let that = this;
      that.$apiFun
        .post('/api/banklist', {})
        .then(res => {
          if (res.code != 200) {
            that.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.banklist = res.data;
          }
          that.hideLoading();
        })
        .catch(res => {
          that.hideLoading();
        });
    },
    getcard() {
      let that = this;
      that.showLoading();
      that.$apiFun
        .post('/api/getpaybank', {})
        .then(res => {
          if (res.code != 200) {
            that.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.cardLis = res.data;

            that.hideLoading();
          }
        })
        .catch(res => {
          that.hideLoading();
        });
    },
    getuseCardlist() {
      let that = this;
      that.$apiFun.post('/api/getcard', { type: 1 }).then(res => {
        if (res.code == 200) {
          that.userbank = res.data;
        }
      });
      that.$apiFun.post('/api/getcard', { type: 2 }).then(res => {
        if (res.code == 200) {
          that.userUSD = res.data;
        }
      });
    },
    changPayway(val) {
      let that = this;
      if (val == that.pay_way) {
        return;
      }
      that.pay_way = val;
      that.bankBox = {};
      that.payInfo = {};
      that.amount = null;
      that.getPayRange();
    },
    goNav(url) {
      let that = this;
      that.$parent.goNav(url);
    },
    doCopy(msg) {
      let cInput = document.createElement('input');
      cInput.style.opacity = '0';
      cInput.value = msg;
      document.body.appendChild(cInput);
      // 选取文本框内容
      cInput.select();

      // 执行浏览器复制命令
      // 复制命令会将当前选中的内容复制到剪切板中（这里就是创建的input标签）
      // Input要在正常的编辑状态下原生复制方法才会生效
      document.execCommand('copy');

      // 复制成功后再将构造的标签 移除
      this.showTost(1, '复制成功！');
    },
    getUserInfo() {
      let that = this;
      that.$parent.getUserInfo();
    },
    showLoading() {
      this.$parent.showLoading();
    },
    hideLoading() {
      this.$parent.hideLoading();
    },
    openKefu() {
      this.$parent.openKefu();
    },
    showTost(type, title) {
      this.$parent.showTost(type, title);
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.getuseCardlist();
    });
  },
};
</script>
<style lang="scss" scoped>
@import '../../../static/css/Deposit_793450d6.94935135.css';
@import '../../../static/css/Transfer_81ba8019.f1b60e17.css';
.usdt__card__1QL7m {
  padding: 13px !important;
}
.spanss {
  float: right;
  cursor: pointer;
  display: none;
}
.usdt__sub_tip__24nbZ:hover .spanss {
  display: block;
}
.usdt__sub_tip__24nbZ:hover {
  background: #d1d6da;
}
.sfff:hover {
  background: none !important;
}

.usdt__card__1QL7m .usdt__sub_tip__24nbZ {
  margin: 0;
}
.usdt__card__1QL7m p {
  margin: 0;
  height: 24px !important;
  line-height: 30px !important;
  box-sizing: border-box;
  padding: 0 6px;
}
</style>



// WEBPACK FOOTER //
// src/components/mine/recharge.vue